import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { getChannelById } from '@wix/wix-vod-shared/dist/src/common/selectors/channels';
import { isVODChannel } from 'shared/utils/channel-helpers';
import { listChannelVideos } from 'api/public/channel-videos/channel-videos';
import { listYoutubeChannelVideos } from 'api/public/youtube/videos';
import { normalizeArrayOfVideos } from 'shared/redux/helpers/normalized';
import { getPublic as getPublicChannel } from 'api/public/channel/channel';
import { hydratedData } from 'services/hydrated-data';

const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEOS.LIST');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export const defaultParams = {
  sort: {
    order: 'custom',
    direction: 'asc',
  },
  paging: {
    size: 1000,
  },
};

export const listPublicChannelVideos = (channelId, options = {}) => {
  _.defaultsDeep(options, defaultParams);

  return async (dispatch, getState) => {
    const state = getState();
    const params = { id: channelId, options };

    dispatch(START(params));

    let response;

    const channel = hydratedData.getChannelResponse()
      ? (await getPublicChannel(channelId)).data
      : getChannelById(state, channelId);

    try {
      if (channel) {
        response = isVODChannel(channel)
          ? await listChannelVideos({ ...options, channelId: channel.id })
          : await listYoutubeChannelVideos(channel, options);
      } else {
        response = await listChannelVideos({ ...options, channelId });

        if (!response.data.length) {
          const channelResponse = await getPublicChannel(channelId);

          if (channelResponse.data.externalId) {
            response = await listYoutubeChannelVideos(
              channelResponse.data,
              options,
            );
          }
        }
      }

      response = {
        ...response,
        data: normalizeArrayOfVideos(response.data),
      };

      dispatch(SUCCESS(params, response));
      return response;
    } catch (error) {
      dispatch(
        FAIL(params, error, {
          analytics: { type: 'error', name: 'shared.channel.videos.list' },
        }),
      );
    }
  };
};
